import React, { useRef, useEffect } from 'react';

const Partbgnd = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    console.log('canvas mounted');

    let particles = [];

    for (let i = 0; i < 100; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 2 + 1,
        speedY: Math.random() * 1 + 0.5,
        opacity: Math.random() * 0.5 + 0.5,
      });
    }

    const animate = () => {
         ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.shadowBlur = 8;
        ctx.shadowColor = 'rgba(255, 180, 100, 0.5)';
        ctx.fillStyle = `rgba(255, 180, 100, ${p.opacity})`;
        ctx.fill();
        p.y += p.speedY;
        if (p.y > canvas.height) p.y = 0;
  });
  requestAnimationFrame(animate);
};

    animate();
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        top: 0,
        left: 0,
        zIndex: 10,
        // background: 'linear-gradient(to bottom, #0F2027, #203A43, #2C5364)',
      }}
    />
  );
};

export default Partbgnd;
